import { render } from "./ConsultantDashboardPage.vue?vue&type=template&id=45befedc"
import script from "./ConsultantDashboardPage.vue?vue&type=script&lang=js"
export * from "./ConsultantDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__